import { render, staticRenderFns } from "./PageManagementNewMove.vue?vue&type=template&id=045463f4&scoped=true"
import script from "./PageManagementNewMove.vue?vue&type=script&lang=js"
export * from "./PageManagementNewMove.vue?vue&type=script&lang=js"
import style0 from "./PageManagementNewMove.vue?vue&type=style&index=0&id=045463f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045463f4",
  null
  
)

export default component.exports